import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const TagGlyph = /*#__PURE__*/createElement("g", {
  id: "tag"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M41.8,21.5c-1.1,0.1-2.6,0.8-3.4,1.6l-23,23c-0.8,0.8-0.8,2.1,0,2.8l20.7,20.7c0.8,0.8,2.1,0.8,2.8,0l23-23 c0.8-0.8,1.5-2.3,1.6-3.4L65.8,21c0.1-1.1-0.7-1.9-1.8-1.8L41.8,21.5z M51.5,38.6c-2.9,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2 s5.2,2.3,5.2,5.2S54.4,38.6,51.5,38.6z"
})));
const Tag = createSvg({
  name: 'tag',
  path: TagGlyph
});

export default Tag;
export { TagGlyph };
